import AemInlineNotification from '@/components/Aem/AemInlineNotification';
import type {ImageModel} from '@/types/content';
import type {InlineNotificationContentModel} from '@/types/content/badgeDetails';
import {INLINE_NOTIFICATION_VARIANTS} from '@/types/content/common';

import BadgeDetailHero from './BadgeDetailHero';

type BadgeDetailHeaderProps = {
    title?: string;
    titleId?: string;
    imageUrl?: string;
    backgroundImage?: ImageModel[];
    notification?: InlineNotificationContentModel | null;
    isEarned?: boolean;
};

/**
 * Hero section for badge detail drawers.
 * Full-width background image (aspect 393/579) with badge centered,
 * three gradient overlays, title and notification at the bottom.
 */
const BadgeDetailHeader = ({
    title,
    titleId,
    imageUrl,
    backgroundImage,
    notification,
    isEarned,
}: BadgeDetailHeaderProps) => (
    <div className='relative aspect-393/579 w-full overflow-hidden'>
        <BadgeDetailHero imageUrl={imageUrl} backgroundImage={backgroundImage} />

        {/* Bottom gradient + progressive blur + title + notification */}
        <div className='absolute inset-x-0 bottom-0 flex flex-col items-center gap-3 bg-linear-to-b from-transparent to-secondary px-4 pt-6 pb-4'>
            <div
                className='mask-[linear-gradient(to_bottom,transparent,black)] pointer-events-none absolute inset-0 backdrop-blur-[20px]'
                aria-hidden
            />

            <div className='relative z-10 flex w-full flex-col items-center gap-4'>
                {title && (
                    <h2 id={titleId} className='m-0 text-center font-bold text-28 leading-143'>
                        {title}
                    </h2>
                )}

                {notification && (
                    <AemInlineNotification
                        model={notification}
                        variant={
                            isEarned ? INLINE_NOTIFICATION_VARIANTS.DEFAULT : INLINE_NOTIFICATION_VARIANTS.GRADIENT
                        }
                        className='bg-obsidian'
                        gradientWrapperClassName='w-full'
                    />
                )}
            </div>
        </div>
    </div>
);

export default BadgeDetailHeader;
